import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled from 'styled-components';
import Text from '../text/text.component.js';
import Button from '../buttons/button.component.js';
import '../../App.css.js';
var _excluded = ["style", "width", "height", "color", "titleText", "captionText", "buttonText", "buttonLink", "buttonIcon", "buttonActive", "linkText", "LinkComponent", "link"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Div = styled.div.withConfig({
  displayName: "zero-fees-cardcomponent__Div",
  componentId: "sc-1nhu0nk-0"
})(["display:flex;box-sizing:border-box;flex-direction:column;justify-content:space-between;background-color:", ";padding-top:78px;padding-left:50px;padding-right:50px;padding-bottom:48px;border-radius:24px;min-height:611px;.div-space{display:block;margin-top:34px;}.title-zero-fees-card{max-width:unset;}.description-zero-fees-card{max-width:unset;}@media screen and (max-width:768px){padding-top:34px;padding-left:24px;padding-right:24px;padding-bottom:34px;border-radius:24px;min-height:286px;.div-space{display:none;margin-top:0px;}.title-zero-fees-card{max-width:254px;}.description-zero-fees-card{max-width:264px;}}"], function (props) {
  return props.color == "green" ? "var(--green)" : "var(--blue)";
});
var TextTitle = styled(Text).withConfig({
  displayName: "zero-fees-cardcomponent__TextTitle",
  componentId: "sc-1nhu0nk-1"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:24px;line-height:32px;}"]);
var TextDescription = styled(Text).withConfig({
  displayName: "zero-fees-cardcomponent__TextDescription",
  componentId: "sc-1nhu0nk-2"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Regular,Arial;font-weight:400;font-size:16px;line-height:22px;}"]);
var ZeroFeesCard = function ZeroFeesCard(_ref) {
  var style = _ref.style,
    width = _ref.width,
    height = _ref.height,
    color = _ref.color,
    titleText = _ref.titleText,
    captionText = _ref.captionText,
    buttonText = _ref.buttonText,
    buttonLink = _ref.buttonLink;
  _ref.buttonIcon;
  var buttonActive = _ref.buttonActive,
    linkText = _ref.linkText,
    LinkComponent = _ref.LinkComponent,
    link = _ref.link,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Div, _extends({
    color: color,
    style: _objectSpread({
      width: width,
      height: height
    }, style)
  }, rest), /*#__PURE__*/React__default.createElement(TextTitle, {
    fontFamily: "euclid",
    type: "heading",
    fontSize: "xxlarge",
    className: "title-zero-fees-card",
    style: {
      textAlign: "center",
      marginLeft: "auto",
      marginRight: "auto",
      whiteSpace: "break-spaces"
    }
  }, titleText), /*#__PURE__*/React__default.createElement(TextDescription, {
    fontFamily: "euclid",
    type: "paragraph",
    fontSize: "large",
    className: "description-zero-fees-card",
    style: {
      textAlign: "center",
      marginLeft: "auto",
      marginRight: "auto",
      paddingTop: "24px",
      paddingBottom: "24px"
    }
  }, captionText), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "button-zero-fees-card",
    type: "primary",
    heightButton: "xlarge",
    textType: "large",
    color: "white",
    borderRadiusValue: "100px",
    LinkComponent: LinkComponent,
    text: buttonText,
    active: buttonActive,
    fontSizeMobile: "14px",
    link: buttonLink,
    style: {
      width: "100%",
      backgroundColor: buttonActive == "false" ? "#eeeff1" : null
    }
  }), link ? /*#__PURE__*/React__default.createElement(LinkComponent, {
    to: link,
    title: linkText,
    style: {
      textDecoration: "none",
      marginTop: "34px",
      maxHeight: "39px",
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    fontFamily: "euclid",
    type: "label",
    fontSize: "large",
    style: {
      textAlign: "center"
    }
  }, linkText)) : /*#__PURE__*/React__default.createElement("div", {
    className: "div-space",
    style: {
      minHeight: "19px"
    }
  })));
};
export { ZeroFeesCard as default };